<template>
  <b-card no-body class="root mb-2" style="overflow: hidden;" tag="div">
    <router-link
      tag="div"
      :class="[{ clickable: !playlist.isEmpty }, 'videoOverlay']"
      :to="
        playlist.isEmpty || playlist.portal == 'GLAD'
          ? ''
          : { name: 'playlist', params: { id: playlist.id } }
      "
      @click.native="$emit('open')"
    >
      <div v-if="playlist.isEmpty || loading" class="text-light2 bg-light">
        <div style="padding: 20% 0 37%; text-align: center; font-size: 40px; height: 0;">
          <loader />
        </div>
      </div>
      <LazyImage
        v-else
        :src="playlist.image"
        :width="playlist.image_width"
        :height="playlist.image_height"
        :overlay="{ icon: 'play' }"
      />
    </router-link>

    <b-card-body class="pt-2" v-if="playlist.isEmpty"></b-card-body>

    <b-card-body class="pt-2" v-else>
      <div class="row no-gutters">
        <b-col>
          <router-link
            tag="div"
            class="clickable"
            :to="
              playlist.isEmpty || playlist.portal == 'GLAD'
                ? ''
                : { name: 'playlist', params: { id: playlist.id } }
            "
            @click.native="$emit('open')"
          >
            <h5 class="pt-3 mb-0">{{ playlist.title }}</h5>
          </router-link>
        </b-col>
        <b-col v-if="user && playlist.portal === 'RHEUMAFIT'" md="auto" class="pt-3">
          <FavIndicator :playlistId="playlist.id" :isFavourite="playlist.isFavourite" />
        </b-col>
      </div>
      <div class="row">
        <div class="col">
          <b>{{ playlist.tagline }}</b>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <p class="card-text">
            <vue-markdown>{{ playlist.description }}</vue-markdown>
          </p>
        </div>
      </div>
    </b-card-body>

    <b-card-footer footer-border-variant="light" v-if="playlist.portal === 'RHEUMAFIT'">
      <div class="row" style="height: 26px;">
        <div :class="['col-5', { 'text-light2': playlist.isEmpty }]">
          <p>{{ $t('COMPONENT_playlistcard_duration') }}</p>
        </div>
        <div :class="['col-7', { 'text-light2': playlist.isEmpty }]">
          <p>
            {{ playlist.isEmpty ? '30' : Math.ceil(playlist.duration / 60) }}
            {{ $t('minutes') }}
          </p>
        </div>
      </div>
      <div class="row" style="height: 26px;">
        <div :class="['col-5', { 'text-light2': playlist.isEmpty }]">
          <p>{{ $t('COMPONENT_playlistcard_intensity') }}</p>
        </div>
        <div class="col-7">
          <b-progress
            :value="playlist.intensity"
            :max="3"
            height="0.5rem"
            variant="green"
            style="margin-top: 6px;"
          />
        </div>
      </div>
      <div class="row" style="height: 26px;">
        <div :class="['col-5', { 'text-light2': playlist.isEmpty }]">
          <p>{{ $t('COMPONENT_playlistcard_bodyparts') }}</p>
        </div>
        <div class="col-7">
          <BodyParts :showInactive="true" :parts="playlist.areas" />
        </div>
      </div>
      <div class="row" style="height: 26px;">
        <div :class="['col-5', { 'text-light2': playlist.isEmpty }]">
          <p>{{ $t('COMPONENT_playlistcard_rating') }}</p>
        </div>
        <div class="col-7">
          <stars :rating="playlist.isEmpty ? 0 : playlist.rating" />
        </div>
      </div>
    </b-card-footer>
  </b-card>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import { mapGetters } from 'vuex';

import Stars from '@/components/Stars';
import LazyImage from '@/components/LazyImage';
import BodyParts from '@/elements/BodyParts';
import Loader from '@/components/Loader';
import FavIndicator from '@/elements/FavIndicator';
import config from '@/config';

export default {
  name: 'PlaylistCard',
  components: {
    Stars,
    LazyImage,
    BodyParts,
    Loader,
    FavIndicator,
    VueMarkdown,
  },
  computed: {
    ...mapGetters(['user']),
    availableBodyParts() {
      return config.availableBodyParts;
    },
  },
  props: ['playlist', 'loading'],
};
</script>

<style scoped>
.image {
  height: 20px;
  width: 21px;
  display: inline-block;
  margin-right: 1px;
}

.image_body {
  background: url('../../assets/body.svg') no-repeat;
}

.image_body_grey {
  background: url('../../assets/body_g.svg') no-repeat;
}

.image_back {
  background: url('../../assets/back.svg') no-repeat;
}

.image_back_grey {
  background: url('../../assets/back_g.svg') no-repeat;
}

.image_shoulder {
  background: url('../../assets/shoulder.svg') no-repeat;
}

.image_shoulder_grey {
  background: url('../../assets/shoulder_g.svg') no-repeat;
}

.image_leg {
  background: url('../../assets/leg.svg') no-repeat;
}

.image_leg_grey {
  background: url('../../assets/leg_g.svg') no-repeat;
}

.image_hip {
  background: url('../../assets/hip.svg') no-repeat;
}

.image_hip_grey {
  background: url('../../assets/hip_g.svg') no-repeat;
}

.image_neck {
  background: url('../../assets/neck.svg') no-repeat;
}

.image_neck_grey {
  background: url('../../assets/neck_g.svg') no-repeat;
}

.videoOverlay {
  width: 100%;
  overflow: hidden;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/PlaylistCard/Client.vue